.hero {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: var(--space-7);
  align-items: center;
  min-height: 60vh;
}

.copy {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.title {
  font-family: var(--font-display);
  font-size: clamp(1.75rem, 6vw, 3.25rem);
  letter-spacing: var(--letter-spacing-display);
  line-height: var(--line-height-tight);
  color: var(--color-fg);
  margin: 0;
  text-shadow: 4px 4px 0 var(--color-magenta);
}

.tagline {
  font-family: var(--font-body);
  font-size: var(--font-size-body-lg);
  color: var(--color-fg-muted);
  margin: 0;
  max-width: 52ch;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-top: var(--space-3);
}

.socials {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-top: var(--space-4);
  position: relative;
  z-index: calc(var(--z-navbar) + 1);
}

.socialsLabel {
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-fg-muted);
  text-transform: uppercase;
}

.avatarWrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (max-width: 820px) {
  .hero {
    grid-template-columns: 1fr;
    gap: var(--space-5);
    text-align: left;
  }
  .avatarWrap {
    order: -1;
    justify-content: flex-start;
  }
}
